export const BUDGET_LIFETIME = 'budget_lifetime'
export const IMPRESSIONS = 'impressions'
